import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepOtherTugo = (state) => state.get('stepOtherTugo');

const makeSelectStepOtherTugo = () => createSelector(
  selectStepOtherTugo,
  (stepOtherState) => ({
    // Other SCTI
    whatExpensesAreYouClaimingFor: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      ''
    ),
    repatriationBenefitItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'repatriationBenefitItems']) && stepOtherState.getIn(['form', 'repatriationBenefitItems']).toJS(), ''),
    repatriationItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'repatriationItems']) && stepOtherState.getIn(['form', 'repatriationItems']).toJS(), ''),
    returnHomeBenefitItems: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'returnHomeBenefitItems']) && stepOtherState.getIn(['form', 'returnHomeBenefitItems']).toJS(),
      ''
    ),
    deathRemainsItems: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'deathRemainsItems']) && stepOtherState.getIn(['form', 'deathRemainsItems']).toJS(),
      ''
    ),
    deathBurialItems: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'deathBurialItems']) && stepOtherState.getIn(['form', 'deathBurialItems']).toJS(),
      ''
    ),
    deathTransportItems: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'deathTransportItems']) && stepOtherState.getIn(['form', 'deathTransportItems']).toJS(),
      ''
    ),
    airFlightCommonCarrierAccidentItems: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'airFlightCommonCarrierAccidentItems']) && stepOtherState.getIn(['form', 'airFlightCommonCarrierAccidentItems']).toJS(),
      ''
    ),
    accident24HourItems: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'accident24HourItems']) && stepOtherState.getIn(['form', 'accident24HourItems']).toJS(),
      ''
    ),
    expensesRelatedToDeathParentSelected: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'expensesRelatedToDeathParentSelected']),
      false
    ),
    accidentalDeathAndDismembermentParentSelected: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'accidentalDeathAndDismembermentParentSelected']),
      false
    ),
  })
);

const makeSelectStepOtherTugoErrors = () =>
  createSelector(selectStepOtherTugo, (state) => state.get('errors'));

export {
  makeSelectStepOtherTugo,
  makeSelectStepOtherTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/selectors.js